import { render, staticRenderFns } from "./NewBurnRateTriggers.vue?vue&type=template&id=01f3740f&"
import script from "./NewBurnRateTriggers.vue?vue&type=script&lang=js&"
export * from "./NewBurnRateTriggers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/dashboard/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSlider } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCard,VContainer,VDivider,VFlex,VLayout,VSlider,VSubheader,VTextField})
